export const lang = {
  national_id:"CIN",
  save_success: 'Patient enregistré!',
  patient_file:"Fiche patient",
  is_insured:"Assuré"
};
